import {
  Form,
} from "@/shared/ui/form.tsx"
import { useForm } from "react-hook-form"
import { ActivityScoresDataSchema, ActivityScoresDataType } from "../types"
import { zodResolver } from "@hookform/resolvers/zod"
import FormSectionOne from "./components/FormSectionOne"
import { Button } from "@/shared/ui/button.tsx"

const CalibrationForm = () => {
  const form = useForm<ActivityScoresDataType>({
    resolver: zodResolver(ActivityScoresDataSchema)
  })

  const submitHandler = (data: ActivityScoresDataType) => {
    console.log(data)
  }

  return (
    <div className="w-full ">
      <Form {...form}>
      <form onSubmit={form.handleSubmit(submitHandler)} className="space-y-8">
          <FormSectionOne />
          <div className="flex items-center justify-end gap-3">
            <Button variant="outline">Back</Button>
            <Button className="bg-theme-primary">Next</Button>
          </div>
      </form>
      </Form>
    </div>
  )
}

export default CalibrationForm;
